import script from "./summary-statement-step2.vue?vue&type=script&setup=true&lang=ts"
export * from "./summary-statement-step2.vue?vue&type=script&setup=true&lang=ts"

import "./summary-statement-step2.vue?vue&type=style&index=0&id=ba224e7c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba224e7c"]])

export default __exports__